import React, { useMemo, useEffect, useState } from 'react';
import { getDrivers } from '../api';

export default function DriverSelector({ value, onChange, includeNoDnf = false, drivers: driversProp }) {
    const [driversFromApi, setDriversFromApi] = useState([]);

    useEffect(() => {
        // Only fetch all drivers if no prop provided
        if (driversProp) return;
        let mounted = true;
        getDrivers().then((list) => { if (mounted) setDriversFromApi(list || []); });
        return () => { mounted = false; };
    }, [driversProp]);

    const drivers = driversProp || driversFromApi;

    // Build final driver list (objects)
    const driverList = useMemo(() => {
        const mapped = (drivers || []).map((d) => {
            if (typeof d === 'string') {
                return { id: d, name: d, team: '', color: 'var(--f1-light-gray)', logo: '' };
            }
            // backend driver object shape: { first_name, last_name, team_name, team_color_primary, ... }
            const first = d.first_name || d.firstName || '';
            const last = d.last_name || d.lastName || '';
            const full = (d.name || `${first} ${last}`.trim() || d.code || d.id || '').trim();
            const team = d.team_short_name || d.team || '';
            const color = d.team_color_primary || d.color || 'var(--f1-light-gray)';
            const logo = d.logo || '';
            return { id: d.id, name: full, team, color, logo };
        });
        if (!includeNoDnf) return mapped;
        return [{ id: null, name: 'No DNF', team: 'None', color: 'var(--f1-light-gray)', logo: '' }, ...mapped];
    }, [drivers, includeNoDnf]);

    const selectedDriver = driverList.find((d) => String(d.id) === String(value) || d.name === value) || null;

    const handleSelect = (driver) => { onChange && onChange(driver.id); };
    const formatLabel = (driver) => (driver && driver.team && driver.team !== 'None'
        ? `${driver.name} (${driver.team})`
        : (driver ? driver.name : ''));

    return (
        <div className="dropdown col-10 ">
            <div className='driver-dropdown'>
                <button
                    className="btn btn-secondary dropdown-toggle d-flex align-items-center "
                    data-bs-toggle="dropdown"
                    style={{
                        borderLeft: selectedDriver
                            ? `6px solid ${selectedDriver.color}`
                            : undefined
                    }}
                >
                    {selectedDriver ? (
                        <>
                            {/* <img
                                src={selectedDriver.logo}
                                alt={selectedDriver.team}
                                className="team-logo me-2"
                            /> */}
                            {formatLabel(selectedDriver)}
                        </>
                    ) : (
                        "Select Driver"
                    )}
                </button>

                <ul className="dropdown-menu">
                    {driverList.map((driver) => (
                        <li key={driver.id != null ? String(driver.id) : driver.name}>
                            <button
                                className="dropdown-item driver-dropdown-item"
                                style={{ borderLeft: `6px solid ${driver.color}` }}
                                onClick={() => handleSelect(driver)}
                            >
                                {/* <img
                                    src={driver.logo}
                                    alt={driver.team}
                                    className="team-logo me-2"
                                /> */}
                                {formatLabel(driver)}
                            </button>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
}


// import { teams } from "./teams";

// export default function TeamDropdown({ onSelect }) {
//     const [selected, setSelected] = useState(null);

//     const handleSelect = (team) => {
//         setSelected(team);
//         onSelect(team);
//     };

//     return (
//         <div className="dropdown">
//             <button
//                 className="btn btn-secondary dropdown-toggle d-flex align-items-center"
//                 data-bs-toggle="dropdown"
//             >
//                 {selected ? (
//                     <>
//                         <img
//                             src={selected.logo}
//                             alt={selected.name}
//                             className="team-logo me-2"
//                         />
//                         {selected.name}
//                     </>
//                 ) : (
//                     "Select Team"
//                 )}
//             </button>

//             <ul className="dropdown-menu team-dropdown-menu">
//                 {teams.map((team) => (
//                     <li key={team.name}>
//                         <button
//                             className="dropdown-item team-dropdown-item"
//                             style={{ borderLeft: `6px solid ${team.color}` }}
//                             onClick={() => handleSelect(team)}
//                         >
//                             <img src={team.logo} alt={team.name} className="team-logo me-2" />
//                             {team.name}
//                         </button>
//                     </li>
//                 ))}
//             </ul>
//         </div>
//     );
// }
